import { Grid, Card, CardContent, CardHeader } from '@mui/material';

import { InfoField, Typography } from '@occc/ui-design-system';

import { LocationAddressGeolocationCardMap } from './location-address-geolocation-card-map.component';
import { LocationAddressGeolocation } from './location-address-geolocation-card.types';

type LocationAddressGeolocationCardProps = {
  geoLocation: LocationAddressGeolocation | null;
  hasAddress: boolean;
};

export const LocationAddressGeolocationCard = ({
  geoLocation,
  hasAddress,
}: LocationAddressGeolocationCardProps) => {
  return (
    <Card sx={{ mb: 3 }}>
      <CardHeader title={<Typography variant='h6'>Location on Map</Typography>} />
      <CardContent>
        <Grid container spacing={3} alignItems='end'>
          <Grid item xs={12} md={3}>
            <InfoField
              sx={{ m: 0 }}
              label='Latitude'
              value={geoLocation?.latitude}
              noDataMessage=''
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <InfoField
              sx={{ m: 0 }}
              label='Longitude'
              value={geoLocation?.longitude}
              noDataMessage=''
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ '&.MuiGrid-item': { pt: 0 } }}>
            <LocationAddressGeolocationCardMap geolocation={geoLocation} hasAddress={hasAddress} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
